export default __webpack_public_path__ + "static/media/checkIcon.bec41e20.svg";